<template>
  <div
    class="date-picker-component-view overview-card p-5"
    :class="{
      'd-none': !visible,
      'position-relative': positionRelative,
      'position-absolute': !positionRelative,
      'display-on-top': displayOnTop
    }"
  >
    <div class="d-flex align-items-center justify-content-between header">
      <button
        class="btn btn-control-date text-primary"
        @click="previous"
        :disabled="type === 'today'"
      >
        <i class="icon-angle-left" />
      </button>
      <form-group
        v-model="month"
        id="month-1"
        placeholder="Selecione"
        select
        :disabled="type === 'today'"
        :options="monthList"
        class="mx-2 py-0"
      />
      <form-group
        v-model="year"
        id="year-1"
        placeholder="Selecione"
        :disabled="type === 'today'"
        select
        :options="yearList"
        class="mx-2 py-0"
      />
      <button
        class="btn btn-control-date text-primary"
        @click="next"
        :disabled="type === 'today'"
      >
        <i class="icon-angle-right" />
      </button>
    </div>
    <div class="row my-3 type-picker" v-if="pickerOptions">
      <div class="col-4">
        <button
          class="btn btn-block"
          :class="type === 'today' ? 'btn-primary' : 'btn-outline-secondary'"
          @click="changePickerType('today')"
        >
          Hoje
        </button>
      </div>
      <div class="col-4">
        <button
          class="btn btn-block"
          :class="type === 'day' ? 'btn-primary' : 'btn-outline-secondary'"
          @click="changePickerType('day')"
        >
          Dia
        </button>
      </div>
      <div class="col-4">
        <button
          class="btn btn-block"
          :class="type === 'range' ? 'btn-primary' : 'btn-outline-secondary'"
          @click="changePickerType('range')"
        >
          Período
        </button>
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-center">
      <table class="mb-6 text-center">
        <thead>
          <tr>
            <th
              v-for="(name, idx) in DAYS_NAME"
              :key="`head-th-${idx}`"
              scope="col"
              class="text-dark bg-lg-white p-3"
            >
              <strong>{{ name[0] }}</strong>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(line, i) in lines" :key="`body-tr-${i}`">
            <th
              v-for="(day, index) in DAYS_LIST.slice(line.start, line.end)"
              :key="`body-th-${index}`"
              class="bg-lg-white"
            >
              <button
                class="btn"
                :class="{
                  'sunday-color': index === 0,
                  'text-secondary': !day.isCurrentMonth,
                  'btn-primary': isStartOrEndDay(day),
                  'btn-in-range': isInRange(day),
                  'btn-before-start': isBeforeStart(day)
                }"
                :disabled="isDisabled(day)"
                @click="selectDay(day)"
              >
                {{ day.day }}
              </button>
            </th>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="d-flex justify-content-center btn-submit-wrapper">
      <button type="button" class="btn btn-primary px-6" @click="submit">
        Aplicar
      </button>
    </div>
    <div
      v-if="showCancelBtn"
      class="d-flex justify-content-center btn-submit-wrapper"
    >
      <button type="button" class="btn text-danger px-6" @click="cancel">
        Limpar
      </button>
    </div>
  </div>
</template>
<script>
import { MAP_MONTH_NAME, MAP_MONTH_NUMBER } from "@/constants/date";
import { getArrayOfDaysInMonth, getYearRange } from "@/functions/helpers";

import moment from "moment";

const DATE_SHAPE = "YYYY-MM-DD";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    showCancelBtn: {
      type: Boolean,
      default: false
    },
    positionRelative: {
      type: Boolean,
      default: false
    },
    displayOnTop: {
      type: Boolean,
      default: false
    },
    value: {
      //example: ['2021-05-10', '2021-05-17] [0] -> start_day -- [1] -> end_day
      type: Array,
      default: () => []
    },
    pickerOptions: {
      type: Boolean,
      default: false
    },
    pickerType: {
      type: String,
      default: "range"
    }
  },
  data() {
    return {
      DAYS_NAME: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
      DAYS_LIST: [],
      lines: [
        { start: 0, end: 7 },
        { start: 7, end: 14 },
        { start: 14, end: 21 },
        { start: 21, end: 28 },
        { start: 28, end: 35 },
        { start: 35, end: 42 }
      ],
      start_day: undefined,
      end_day: undefined,
      year: new Date().getFullYear(),
      month: MAP_MONTH_NAME[new Date().getMonth() + 1].name,
      innerValue: [],
      type: this.pickerType
    };
  },
  computed: {
    monthList() {
      return Object.entries(MAP_MONTH_NAME).map(([_, { name }]) => ({
        id: name,
        name
      }));
    },
    yearList() {
      const currentYear = new Date().getFullYear();
      return [...getYearRange(currentYear + 10, currentYear - 20, -1)]
        .sort()
        .map(y => ({ id: y, name: y }));
    }
  },
  mounted() {
    this.DAYS_LIST = getArrayOfDaysInMonth(
      this.year,
      MAP_MONTH_NUMBER[this.normalizeMonth(this.month)]
    );
  },
  watch: {
    value(val) {
      if (
        val &&
        val.length > 0 &&
        moment(val[0], DATE_SHAPE).isValid() &&
        moment(val[1], DATE_SHAPE).isValid()
      ) {
        this.start_day = val[0];
        this.end_day = val[1];
      } else {
        this.start_day = undefined;
        this.end_day = undefined;
      }
    },
    start_day(val) {
      const aux = this.innerValue;
      aux[0] = val;
      this.innerValue = aux;
    },
    end_day(val) {
      const aux = this.innerValue;
      aux[1] = val;
      this.innerValue = aux;
    },
    month(newVal) {
      this.DAYS_LIST = getArrayOfDaysInMonth(
        this.year,
        MAP_MONTH_NUMBER[this.normalizeMonth(newVal)]
      );
    },
    year(newVal) {
      this.DAYS_LIST = getArrayOfDaysInMonth(
        newVal,
        MAP_MONTH_NUMBER[this.normalizeMonth(this.month)]
      );
    }
  },
  filters: {
    formatDate(value) {
      return moment(value, "YYYY-MM-DD hh:mm:ss").format("HH:mm");
    }
  },
  methods: {
    changePickerType(v) {
      this.type = v;

      if (v === "today") {
        let day = moment().format(DATE_SHAPE);
        this.start_day = day;
        this.end_day = day;

        this.year = new Date(day).getFullYear();
        this.month = MAP_MONTH_NAME[new Date(day).getMonth() + 1].name;
      } else {
        this.start_day = undefined;
        this.end_day = undefined;
      }
    },
    getMonthNumber() {
      return MAP_MONTH_NUMBER[this.normalizeMonth(this.month)];
    },
    prepareMonthAndYear(item) {
      let month = this.getMonthNumber();
      let year = this.year;
      if (item.monthPosition === "before") {
        if (month === 1) {
          month = 12;
          year -= 1;
        } else {
          month = month - 1;
        }
      }

      if (item.monthPosition === "next") {
        if (month === 12) {
          month = 1;
          year += 1;
        } else {
          month = month + 1;
        }
      }

      return { month, year };
    },
    isStartOrEndDay(item) {
      const { month, year } = this.prepareMonthAndYear(item);

      const isStart = moment(`${year}-${month}-${item.day}`, DATE_SHAPE).isSame(
        moment(this.start_day, DATE_SHAPE),
        "day"
      );

      const isEnd = moment(`${year}-${month}-${item.day}`, DATE_SHAPE).isSame(
        moment(this.end_day, DATE_SHAPE),
        "day"
      );

      return isStart || isEnd;
    },
    isInRange(item) {
      const { month, year } = this.prepareMonthAndYear(item);

      const completedDay = `${year}-${month}-${item.day}`;

      return moment(completedDay, DATE_SHAPE).isBetween(
        moment(this.start_day, DATE_SHAPE),
        moment(this.end_day, DATE_SHAPE)
      );
    },
    isBeforeStart(item) {
      const { month, year } = this.prepareMonthAndYear(item);

      const completedDay = `${year}-${month}-${item.day}`;

      const isBefore =
        (moment(completedDay, DATE_SHAPE).isBefore(
          moment(this.start_day, DATE_SHAPE)
        ) &&
          this.type !== "day") ||
        (this.type === "today" &&
          moment(completedDay, DATE_SHAPE).isAfter(
            moment(this.start_day, DATE_SHAPE)
          ));

      return isBefore;
    },
    normalizeMonth(txt) {
      return `${txt}`
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
    },
    next() {
      const monthNumber = this.getMonthNumber();
      if (monthNumber === 12) {
        this.month = MAP_MONTH_NAME[1].name;
        this.year += 1;
      } else if (monthNumber + 1 <= 12) {
        this.month = MAP_MONTH_NAME[monthNumber + 1].name;
      }
    },
    previous() {
      const monthNumber = this.getMonthNumber();
      if (monthNumber === 1) {
        this.month = MAP_MONTH_NAME[12].name;
        this.year -= 1;
      } else if (monthNumber - 1 > 0) {
        this.month = MAP_MONTH_NAME[monthNumber - 1].name;
      }
    },
    buildDate(item) {
      const { month, year } = this.prepareMonthAndYear(item);

      const completeMonth = month < 10 ? `0${month}` : month;

      const day = item.day < 10 ? `0${item.day}` : item.day;

      return `${year}-${completeMonth}-${day}`;
    },
    isDisabled(item) {
      if (this.start_day !== undefined) return false;

      const mStartDay = moment(this.start_day, DATE_SHAPE);
      const mDayToTest = moment(this.buildDate(item), DATE_SHAPE);

      return mDayToTest.isBefore(mStartDay) || this.type === "today";
    },
    selectDay(item) {
      const selectedDay = this.buildDate(item);

      if (this.type === "today") {
        this.$message.error("Impossível selecionar outra data");
        return;
      }

      if (this.type === "day") {
        this.start_day = selectedDay;
        this.end_day = selectedDay;
        return;
      }

      if (this.isBeforeStart(item)) {
        this.$message.error(
          "Selecione um dia posterior a primeira data selecionada"
        );
        return;
      }

      if (this.start_day === undefined) {
        this.start_day = selectedDay;
      } else if (this.end_day === undefined) {
        this.end_day = selectedDay;
      } else {
        this.start_day = undefined;
        this.end_day = undefined;
      }
    },
    cancel() {
      this.$emit("change-picker", "range");
      this.end_day = undefined;
      this.start_day = undefined;

      this.innerValue = [];
      this.$emit("input", null);
      this.$emit("submit", this.innerValue);
      this.$emit("hide");
    },
    submit() {
      if (this.innerValue.length !== 2) {
        this.$message.error("Selecione uma data inicial e final");
        return;
      } else if (!this.innerValue[0]) {
        this.innerValue = [];
      }
      this.$emit("change-picker", this.type);

      this.$emit("input", this.innerValue);
      this.$emit("submit", this.innerValue);
      this.$emit("hide");
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.date-picker-component-view {
  z-index: 1;
  top: 120%;
  left: 50%;
  transform: translateX(-50%);

  @media screen and (max-width: 991px) {
    top: auto;
    left: 50%;
    transform: translateX(-50%);
  }

  &.display-on-top {
    left: -20%;
    top: 0;
    transform: translateY(-50%);
  }

  table {
    thead {
      th {
        border: 0px solid #fff;
        strong {
          color: #595463;
          font-size: 14px;
        }
      }
    }
    tbody {
      th {
        font-size: 12px;
        padding: 0;
        .btn,
        .btn-outline-primary,
        .btn-outline-secondary,
        .btn-primary,
        .btn-secondary {
          padding: 0 !important;
          min-height: 38px;
          width: 40px;
          font-weight: 400;
        }

        button:hover {
          border: 1px solid $primary;
        }
      }
    }
  }

  .btn,
  .btn-outline-primary,
  .btn-outline-secondary,
  .btn-primary,
  .btn-secondary {
    padding-left: 38px !important;
    padding-right: 38px !important;
    @media screen and (max-width: 991px) {
      padding-left: 20px !important;
      padding-right: 20px !important;
    }
    min-height: 48px;
  }

  .btn-control-date {
    background: #f8f8f9;
    border-radius: 50%;
    min-height: 24px !important;
    padding-left: 12px !important;
    padding-right: 12px !important;
    i {
      font-size: 20px;
    }
  }

  .btn-in-range {
    background: #9155ec15;
    border-radius: 0;
  }

  .btn-before-start {
    color: #928f9860 !important;
  }

  .sunday-color {
    color: #cdcbd4 !important;
  }

  .btn-submit-wrapper {
    button {
      padding-left: 55px !important;
      padding-right: 55px !important;
    }
  }

  ::v-deep.dropdown .btn {
    font-weight: bold !important;
  }

  ::v-deep.form-control {
    border: 1px solid #e1e1e140;
  }

  ::v-deep.el-input__inner {
    border-color: transparent;
  }

  .type-picker {
    .btn,
    .btn-outline-primary,
    .btn-outline-secondary,
    .btn-primary,
    .btn-secondary {
      min-height: 30px;
    }
    .btn-primary {
      color: white;
    }
  }

  .header {
    min-height: 50px;
  }
}
</style>
